export default "__VITE_ASSET__DpoxBX7V__"